export default defineNuxtPlugin((nuxtApp) => {
  // Side-effects from legacy setup.js
  if (import.meta.client) {
    window.history.replaceState = window.history.replaceState || function () {};
  }
});
